import { Route } from '@angular/router';
import { UserEditionComponent } from './user-edition.component';
import { AuthGuard } from '../../../shared/services';
import { UserDetailsResolver } from '../user-details/user-details.resolver';

export const UserEditionRoutes: Route[] = [
    {
      path: 'edit/:id',
      component: UserEditionComponent,
      canActivate: [AuthGuard],
      resolve: {
        user: UserDetailsResolver
      }
    }
  ];
